import React from "react";
import environments from "../../../environments";

import { StandardConsultaPrevia } from "./providers/standard";
import { CastroConsultaPrevia } from "./providers/castro";
import { JacarezinhoConsultaPrevia } from "./providers/jacarezinho";
import { TibagiConsultaPrevia } from "./providers/tibagi";
import { CarambeiConsultaPrevia } from "./providers/carambei";
import { PalmeiraConsultaPrevia } from "./providers/palmeira";
import { IpirangaConsultaPrevia } from "./providers/ipiranga";
import { AraucariaConsultaPrevia } from "./providers/araucaria";
import { WbConsultaPrevia } from "./providers/wb";

export const ConsultaPrevia: React.FC = () => {
    switch (environments.client.name) {
        case "castro":
            return <CastroConsultaPrevia />;
        case "jcz":
            return <JacarezinhoConsultaPrevia />;
        case "tibagi":
            return <TibagiConsultaPrevia />;
        case "carambei":
            return <CarambeiConsultaPrevia />;
        case "palmeira":
            return <PalmeiraConsultaPrevia />;
        case "ipiranga":
            return <IpirangaConsultaPrevia />;
        case "araucaria":
            return <AraucariaConsultaPrevia />;
        case "wb":
            return <WbConsultaPrevia />;
        default:
            return <StandardConsultaPrevia />;
    }
};
